import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ISimplesTabela } from "../../model";

export const TipoSelect = Select.ofType<ISimplesTabela>();

export const filterItens: ItemPredicate<ISimplesTabela> = (query, item) => {
  return `${item.cod.toLowerCase()} - ${item.descricao.toLowerCase()}`.indexOf(query.toLowerCase()) >= 0;
};

export const renderItens: ItemRenderer<ISimplesTabela> = (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={item.cod}
      text={item.descricao}
      label={item.cod}
      onClick={handleClick}
    />
  );
};
